export default {
    "open_equity": "Capital inicial",
    "bonus": "Bono",
    "closed_positions": "Puestos cerrados",
    "finance": "Finanzas",
    "watchlist": "Lista de vigilancia",
    "calendar": "Calendario",
    "symbol_information": "Información sobre símbolos",
    "contact_size": "Tamaño del contacto",
    "min_tick_size": "Tamaño mínimo del tick",
    "min_lot": "Lote mínimo",
    "max_lot": "Lote máximo",
    "pip_size": "Tamaño pipa",
    "stop_limit_levels": "Niveles tope y límite",
    "base_currency": "Cotización de divisas",
    "swap_type": "Tipo de intercambio",
    "digits": "Dígitos",
    "trade_id": "Identificación comercial",
    "sell_buy": "Vender/Comprar",
    "instrument": "Instrumento",
    "open_current_price": "Precio abierto/actual",
    "s_slash_l": "S/L",
    "profit_slash_loss": "Beneficios/pérdidas",
    'net_pl':'P/L Neto',
    "comment": "Comentario",
    "action": "Acción",
    "proximity": "Proximidad",
    "buy_stop": "Comprar Stop",
    "buy_limit": "Límite de compra",
    "stop_loss": "Stop Loss",
    "rate": "Tarifa",
    "take_profit": "Obtenga beneficios",
    "price": "Precio",
    "maximum_20_characters": "Máximo 20 caracteres",
    "btn_place_buy_order": "Realizar pedido de compra",
    "btn_place_sell_order": "Realizar una orden de venta",
    "change": "Cambie",
    "descrption": "Descrption",
    "asset_class": "Clase de activos",
    "subclass": "Subclase",
    "major": "Mayor",
    "size_of_1_pip": "Tamaño de 1 pip",
    "Min_position_size": "Mín. Posición Tamaño",
    "Max_position_size": "Máx. Posición Tamaño",
    "leverage": "Aproveche",
    "daily_swap_points": "Puntos de canje diarios",
    "long": "Largo",
    "short": "corto",
    "market_hours_local_time": "Horario del mercado (hora local)",
    "main_trading": "Principal/Comercio",
    "copy_trade": "Comercio de copias",
    "view_modes": "Ver modos",
    "reports": "Informes",
    "pivot_table": "Tabla dinámica",
    "pp": "PP",
    "s1": "S1",
    "s2": "S2",
    "s3": "S3",
    "r1": "R1",
    "r2": "R2",
    "r3": "R3",
    "list_property": "Lista de propiedades",
    "overview": "Visión general",
    "day_low": "Día Bajo",
    "prev_close": "Anterior Cerrar",
    "day_high": "Día Alto",
    "52_week_low": "Mínimo de 52 semanas",
    "1_day_range": "Gama de 1 día",
    "52_day_range": "Rango de 52 días",
    "daily": "Diario",
    "weekly": "Semanal",
    "monthly": "Mensualmente",
    "moving_averages": "Medias móviles",
    "technical_indicators": "Indicadores técnicos",
    "charts": "Gráficos",
    "trade_log": "Registro comercial",
    "create_new_watchlist": "Crear nueva lista de vigilancia",
    "net_profit": "Beneficio neto",
    "maximum_equity_drawdown": "Disposición máxima del capital",
    "profit_percentage": "Porcentaje de beneficios",
    "opening_balance": "Saldo inicial",
    "current_balance": "Saldo actual",
    "deposit": "Depósito",
    "withdrawal": "Retirada",
    "economic_calendar": "Calendario económico",
    "dashboard": "Cuadro de mandos",
    "markets": "Mercados",
    "portfolio": "Cartera",
    "buzz": "Buzz",
    "view_profile": "Ver perfil",
    "equity": "Equidad",
    "realized_profit": "Beneficio realizado",
    "unrealized_profit": "Beneficio no realizado",
    "balance": "Equilibrio",
    "used_margin": "Margen usado",
    "free_margin": "Margen libre",
    "profile": "Perfil",
    "settings": "Ajustes",
    "theme": "Tema",
    "logout": "Cierre de sesión",
    "trading_account": "Cuenta comercial",
    "quick_links": "Enlaces rápidos",
    "back": "Volver",
    "previous": "Anterior",
    "forecast": "Previsión",
    "actual": "Actual",
    "data": "Fecha",
    "margin_level": "Nivel de margen",
    "news": "Noticias",
    "unrealised_pl": "P/L NETO NO REALIZADO",
    "unrealised_gross_pl": "P/L BRUTO NO REALIZADO",
    "quantity": "Cantidad",
    "trailing_sl": "SL de arrastre",
    "sell": "Venda",
    "buy": "Comprar",
    "open_positions": "Puestos vacantes",
    "close_all_profitable": "Cerrar Todo rentable",
    "close_all_losing": "Cerrar Todas las pérdidas",
    "close_all_buy": "Cerrar Todo Comprar",
    "close_all_sell": "Cerrar Todo Vender",
    "no": "No",
    "yes": "Sí",
    "are_you_sure": "¿Está seguro de que quiere",
    "current_market_rates": "a los tipos actuales del mercado?",
    "close_all": "Cerrar todo",
    "watchlists": "Listas de vigilancia",
    "default": "Por defecto",
    "add_new_watchlist": "Añadir nueva lista de vigilancia",
    "delete_watchlist?": "¿Está seguro de que desea eliminar esta lista de vigilancia?",
    "cancel": "Cancelar",
    "delete": "Borrar",
    "delete_alert": "¿Está seguro de que desea borrar esta alerta?",
    "condition": "Condición",
    "triggered": "Disparado",
    "active": "Activo",
    "alert": "Alerta",
    "alerts": "Alertas",
    "going_below": "Ir abajo",
    "going_above": "Ir más allá",
    "bid_price": "Precio de oferta",
    "ask_price": "Pregunte el precio",
    "symbol": "Símbolo",
    "edit_alert": "Editar alerta",
    "create_alert_on": "Crear alerta en",
    "info": "Información",
    "daily_range": "Alcance diario",
    "spread": "Difundir",
    "contract_size": "Tamaño del contrato",
    "min_trade_size": "Tamaño mínimo de la operación",
    "max_trade_size": "Tamaño máximo de la operación",
    "swap_long": "Intercambio largo",
    "swap_short": "Intercambio corto",
    "create_alert": "Crear alerta",
    "remove_watchlist": "Eliminar de la lista de vigilancia",
    "trading_view_chart": "Trading View Chart",
    "chart": "Gráfico",
    "add": "Añada",
    "add_instruments_watchlist": "Añadir instrumentos a su lista de vigilancia",
    "h": "H",
    "l": "L",
    "cryptos": "Criptomonedas",
    "indices": "Índices",
    "forex": "Forex",
    "fx": "FX",
    "stocks": "Acciones",
    "comm": "Comunicación",
    "commodities": "Materias primas",
    "low": "Bajo",
    "high": "Alta",
    "change_percentage": "Cambio %",
    "bid": "Oferta",
    "ask": "Pregunte a",
    "order": "Pida",
    "commission": "Comisión",
    "swap": "Intercambie",
    "open_date": "Fecha abierta",
    "lots": "Lotes",
    "b_slash_s": "B/S",
    "open_price": "Precio abierto",
    "order_price": "Precio del pedido",
    "current_price": "Precio actual",
    "comments": "Comentarios",
    "modify": "Modifique",
    "close": "Cerrar",
    "ok": "Ok",
    "trailing_stop": " Tope dinámico",
    "trailing_stop_loss": "Trailing Stop Loss",
    "quntity": "Quntity",
    "price_level": "Nivel de precios",
    "type": "Tipo",
    "trades": "Oficios",
    "order_id": "ID de pedido",
    "modify_order": "Modificar orden",
    "revert": "Revertir",
    "id": "ID",
    "sl": "SL",
    "tp": "TP",
    "close_order": "Cerrar pedido",
    "trail_s_slash_l": "Sendero S/L",
    "pnl_s": "Pnl",
    "direction": "Dirección",
    "modify_position": "Modificar posición",
    "close_price": "Cerrar Precio",
    "close_date": "Fecha de cierre",
    "total_p_slash_l": "Total P/L",
    "place_new_order": "Colocar nueva orden",
    "close_time": "Hora de cierre",
    "open_time": "Hora de apertura",
    "p_slash_l": "P/L",
    "reason": "Razón",
    "qty": "Cantidad",
    "pending_orders": "Pedidos pendientes",
    "order_type": "Tipo de pedido",
    "close_all_orders": "¿Está seguro de que desea cerrar todos los Pedidos abiertos?",
    "place_order": "Realizar pedido",
    "advanced_options": "Opciones avanzadas",
    "available_margin": "Margen disponible",
    "trade": "Comercio",
    "positions": "Puestos",
    "orders": "Pedidos",
    "history": "Historia",
    "summary": "Resumen",
    "summary_from": "Resumen de:",
    "performance": "Rendimiento",
    "profitability": "Rentabilidad",
    "password_validation": "La contraseña debe tener al menos 8 caracteres, un carácter especial, una letra y un dígito.",
    "note": "Nota",
    "change_password": "Cambiar contraseña",
    "submit": "Enviar",
    "select_server_type": "Seleccione el tipo de servidor",
    "create_demo_account": "Crear cuenta de demostración",
    "create_new_account": "Crear una nueva cuenta",
    "account_id": "ID de cuenta",
    "name": "Nombre",
    "currency": "Moneda",
    "security": "Seguridad",
    "amount": "Importe",
    "select_leverage": "Seleccionar apalancamiento",
    "select_currency": "Seleccionar moneda",
    "save_settings": "Guardar ajustes",
    "large": "Grande",
    "small": "Pequeño",
    "font_size": "Tamaño de letra",
    "units": "Unidades",
    "select_show": "Seleccione Mostrar",
    "order_position_size": "Pedido / Posición Tamaño En",
    "custom": "A medida",
    "month": "Mes",
    "days": "Días",
    "day": "Día",
    "select": "Seleccione",
    "history_range": "Historia",
    "default_lot_size": "Tamaño predeterminado de la parcela",
    "local_time": "Hora local",
    "server": "Servidor",
    "timezone": "Zona horaria",
    "enable": "Habilite",
    "modify_trade": "Modificar el comercio",
    "open": "Abra",
    "enter_quantity": "Introduzca la cantidad",
    "tooltip": "Información sobre herramientas",
    "field": "Campo",
    "value": "Valor",
    "date_time": "Fecha/Hora",
    "market": "Mercado",
    "all": "Todos",
    "verify": "Verifique",
    "volume": "Volumen",
    "lot": "lote",
    "quantity_required": " Se requiere cantidad.",
    "stop_loss_required": " Se requiere un stop loss.",
    "distance_points": "Distancia del precio actual",
    "points": "Puntos",
    "back_to_login": "Volver al inicio de sesión",
    "forgot_password": "¿Ha olvidado su contraseña?",
    "enter_username": "Introduzca el nombre de usuario",
    "login": "Inicio de sesión",
    "remember_me": "Recuérdame",
    "login_another_account": "Iniciar sesión con otra cuenta",
    "2fa_verification": "Verificación 2FA",
    "my_profile": "Mi perfil",
    "user_name": "Nombre de usuario",
    "email": "Correo electrónico",
    "already_have_account": " ¿Ya tiene una cuenta?",
    "register": "Regístrese en",
    "last_name": "Apellido",
    "first_name": "Nombre",
    "password": "Contraseña",
    "disable_two_factor_auth": "Desactivar la autenticación de dos factores",
    "enter_6_digit_code": "Introduzca el código de verificación de 6 dígitos generado.",
    "enable_two_factor_authentication": "Habilitar la autenticación de dos factores",
    "please_click_2fa_enable": "Haga clic en la opción 2FA que desee activar.",
    "download_authenticator_app": "Descargue una aplicación Authenticator",
    "download_install_google_authenticator": "Descargue e instale Authy o Google Authenticator en su teléfono o tableta.",
    "scan_code": "Escanear el código QR",
    "open_authentication_app_camera": "Abra la aplicación de autenticación y escanee la imagen de la izquierda, utilizando la cámara de su teléfono",
    "login_code": "Inicie sesión con su código",
    "two_factor_authentication": "Autenticación de dos factores",
    "2fa_already_enabled": "2FA Ya Activado Por favor, haga clic en la opción 2FA que desea Desactivar.",
    "usd": "USD",
    "eur": "EUR",
    "gbp": "GBP",
    "aud": "AUD",
    "enter_6_digit_code_placeholder": "Introduzca el código de 6 dígitos",
    "enter_google_verification_code": "Introduzca el código de verificación de Google",
    "trading_id_placeholder": "Introduzca su identificación comercial",
    "password_placeholder": "Introduzca su contraseña",
    "email_placeholder": "Introduzca su correo electrónico",
    "enter_old_password": "Introduzca la contraseña actual",
    "enter_new_password": "Introduzca la nueva contraseña",
    "enter_new_password_again": "Vuelva a introducir la nueva contraseña",
    "alpha_numeric_dashes_underscores_spaces": "el campo sólo puede contener caracteres alfanuméricos, así como guiones, guiones bajos y espacios",
    "is_required": "es necesario",
    "field_must_be": " campo debe ser",
    "or_more": "o más.",
    "or_less": "es o menos.",
    "must_be_greater_then": "debe ser mayor entonces.",
    "must_be_less_then": "debe ser inferior a",
    "not_valid": "no es válido",
    "buy_stop_loss_error_message": "El Stop Loss debe ser inferior al Precio de Mercado",
    "trailing_stop_required": "Se requiere Trailing Stop.",
    "trailing_stop_greater_zero": "El Trailing Stop debe ser Mayor que",
    "target_price_required": "El precio objetivo es obligatorio.",
    "target_price_greater_trigger": "Precio objetivo Debe ser mayor que el precio actual y",
    "trigger_price": "Precio de activación",
    "price_required": "El precio es obligatorio.",
    "price_must_be_greater_than": "El precio debe ser superior a",
    "target_price_greater_price_level": "El precio objetivo debe ser mayor que el nivel de precios",
    "price_must_be_less_than": "El precio debe ser inferior a",
    "and_greater_than_zero": "y Mayor que",
    "stop_loss_less_price_level_greater_zero": "Stop loss debe ser menor que Nivel de Precio y Mayor que",
    "target_price_less_trigger": "El precio objetivo debe ser menor que el precio actual y mayor que",
    "sell_stop": "Tope de venta",
    "sell_limit": "Límite de venta",
    "sell_stop_loss_error_message": "El Stop Loss debe ser superior al Precio de Mercado",
    "placed_order_pending_wait": "Su Pedido está pendiente por favor espere",
    "place_other_order": "Hacer otro pedido",
    "no_account_id_found": "No se ha encontrado ningún ID de cuenta",
    "target_price_must_less_than_trigger_price_greater_zero": "El precio objetivo debe ser menor que el precio de activación y mayor que",
    "sell_stop_loss_greater_trigger_price": "El Stop Loss debe ser superior al precio de activación",
    "create_new_alert": "Crear una nueva alerta",
    "losing": "Perdiendo",
    "winning": "Ganar",
    "avg_trade_size": "Tamaño medio de las operaciones",
    "asset": "Activo",
    "trades_lost": "Operaciones perdidas",
    "trades_won": "Operaciones ganadas",
    "total_trades": "Total Operaciones",
    "total_trading_volume": "Volumen total negociado",
    "resend": "Vuelva a enviar",
    "reset_password_msg": "Por favor, compruebe la dirección de correo electrónico para las instrucciones para restablecer su contraseña.",
    "server_type": "Tipo de servidor",
    "check_email": "Compruebe su correo electrónico",
    "technicals": "Datos técnicos",
    "disable": "Desactive",
    "amount_greater_100000": "El importe no debe ser superior a 100000",
    "x": "X",
    "password_required": "Se requiere contraseña.",
    "proceed": "Proceda",
    "turnkey_forex": "TurnkeyForex",
    "coinexx": "Coinexx",
    "finpro_trading": "Finpro Trading",
    "hankotrade": "Hankotrade",
    "brokers": "Corredores",
    "select_broker": "Seleccione un corredor",
    "edit_price_alert": "Editar alerta de precios",
    "create_price_alert": "Crear alerta de precios",
    "maximum_100_characters": "Máximo 100 caracteres",
    "add_comment": "Añadir comentario",
    "price_must_be": "El precio debe ser",
    "then": "entonces",
    "crossing_above": "Cruzar por encima",
    "crossing_below": "Cruce por debajo",
    "total_records": "Registros totales",
    "no_data_found": "No se han encontrado datos",
    "show_more": "Mostrar más",
    "show_less": "Mostrar menos",
    "at": "en",
    "trail": "Sendero",
    "order_pending": "Pedido pendiente",
    "target_price_less_market_greater_zero": "El Precio Objetivo debe ser menor que el Rango de Mercado y Mayor que",
    "stop_loss_less_market_price_greater_zero": "El Stop Loss debe ser inferior al Precio de Mercado Actual y superior a",
    "stop_loss_greater_market_range": "El Stop Loss debe ser Mayor que el Rango de Mercado",
    "target_price_greater_market_price": "El precio objetivo debe ser mayor que el precio de mercado actual",
    "watchlist_create": "Crear lista de vigilancia",
    "update": "Actualización",
    "delete_symbol": "Borrar símbolo",
    "are_sure_delete_symbol": "¿Está seguro de querer borrar este Símbolo?",
    "symbol_name": "Nombre del símbolo",
    "edit_symbol": "Editar símbolo",
    "enter_watchlist_name": "Introduzca el nombre de la lista de vigilancia",
    "search_title": "Buscar símbolos",
    "b": "B",
    "s": "S",
    "a": "A",
    "username": "Nombre de usuario",
    "email_address": "Dirección de correo electrónico",
    "old_password_validation": "Se requiere una contraseña antigua.",
    "old_password_greater_characters": "La contraseña antigua no puede tener más de 20 caracteres",
    "new_password_validation": "Se requiere una nueva contraseña",
    "confirm_password_is_required": "Es necesario confirmar la contraseña.",
    "entered_password_not_match": "Las contraseñas introducidas no coinciden. Por favor, inténtelo de nuevo",
    "display_high_slash_low_grid_view": "Mostrar Alto / Bajo en la vista de cuadrícula",
    "display_spread_grid_view": "Visualizar la dispersión en vista de cuadrícula",
    "select_to_date": "Seleccionar hasta la fecha",
    "select_from_date": "Seleccionar fecha de inicio",
    "select_show_order_slash_position_size_in": "Mostrar orden / posición Tamaño en",
    "select_history_range": "Seleccione el intervalo del historial",
    "lot_size_greater_than": "El tamaño del lote no debe ser superior a",
    "select_time_zone": "Seleccione la zona horaria",
    "select_font_size": "Seleccione el tamaño de letra",
    "select_mode_view_suits": "Seleccione el modo de visualización que más le convenga.",
    "selected": "Selección",
    "basic_chart_view": "Vista básica del gráfico",
    "grid_view": "Vista en cuadrícula",
    "multi_chart_view": "Vista multigráfica",
    "settings_effect_trading_page": "Estos ajustes sólo tienen efecto en la página de negociación.",
    "market_watch": "Observación del mercado",
    "favorite": "Favoritos",
    "one_click_trading": "Trading con un clic",
    "new_watchlist": "Nueva lista de vigilancia",
    "maximum_5_watchlists": "Puede crear un máximo de 5 listas de vigilancia.",
    "new_watchlist_successfully": "La nueva lista de vigilancia se ha añadido correctamente",
    "delete_watchlist": "Borrar lista de vigilancia",
    "delete_watchlist_successfully": "La lista de vigilancia se ha borrado correctamente",
    "edit_watchlist": "Editar lista de vigilancia",
    "watchlist_updated_successfully": "La lista de vigilancia se ha actualizado correctamente",
    "go_to_order": "Ir al pedido",
    "search_filter_fx": "FX",
    "mon": "Lun",
    "tue": "Mar",
    "wed": "Mie",
    "thu": "Jue",
    "fri": "Vie",
    "sat": "Sáb",
    "sun": "Sol",
    "olivia_deo": "Olivia Deo",
    "risk": "Riesgo",
    "profit": "Beneficios",
    "copiers": "Copiadoras",
    "win_rate": "Porcentaje de victorias",
    "greetings_des": "Saludos, mi sistema que presento aquí requiere la siguiente configuración de la cuenta: 600usd--->0.01Lots Hacemos veeeery Pocos oficios aquí anualmente, entre 60-200 oficios, Los oficios muy necesarios para que - mantenemos nuestro drawdown lo más bajo posible tomando los oficios muy necesarios. -Nos crucero por encima de un promedio de 30 pips por comercio. *Permitimos que todas las operaciones de este sistema logren resultados similares. Así que siéntase bienvenido a medida que crece su cuenta de manera constante con nosotros y ser muy paciente.",
    "live_profit": "Beneficio vivo",
    "overall": "En general",
    "advanced_seats": "Asientos avanzados",
    "trading": "Comercio",
    "drawDown": "DrawDown",
    "pips": "Pips",
    "include_unrealized_pnl": "Incluir Pnl no realizado",
    "closed_trades_only": "Sólo operaciones cerradas",
    "trades_volume": "Volumen de operaciones",
    "by_pair": "Por parejas",
    "best_worst": "Lo mejor-lo peor",
    "ranking": "Clasificación",
    "paris": "París",
    "trading_news": "Noticias comerciales",
    "prev": "Prev",
    "next": "Siguiente",
    "follow": "Siga",
    "investment": "Inversión",
    "open_date_time": "Fecha y hora de apertura",
    "close_date_time": "Fecha y hora de cierre",
    "roll": "Rollo",
    "total": "Total",
    "aud_slash_cad": "AUD/CAD",
    "position_list": "Lista de puestos",
    "trade_history": "Historia del comercio",
    "completed": "Completado",
    "rejected": "Rechazado",
    "pending_closed": "Pendiente Cerrado",
    "close_time_date": "Hora de cierre fecha",
    "status": "Estado",
    "hedge_position": "Posición de cobertura",
    "partial_close": "Cierre parcial",
    "stop_loss_less_then": "El stop loss debe ser inferior a",
    "greater_then_zero": "y Mayor entonces",
    "trailing_stop_greater_one": "El Trailing Stop debe ser Mayor que",
    "greater_then": "El precio objetivo debe ser mayor que",
    "stop_loss_greater_then": "Stop loss debe ser Mayor entonces",
    "target_price_less_then": "El precio objetivo debe ser inferior a",
    "volume_required": "Se requiere volumen.",
    "volume_less_then": "El volumen debe ser inferior a",
    "PNL": "PNL",
    "lot_size_partial": "El tamaño del lote es inferior al cierre parcial",
    "price_greater_then": "El precio debe ser superior a",
    "stop_loss_less_greater_then_zero": "Stop loss debe ser menor que Nivel de Precio y Mayor que 0",
    "trailing_stop_greate_then_zero": "El Trailing Stop debe ser Mayor entonces",
    "stop_loss_trigger_price": "El Stop Loss debe ser mayor que el precio de activación",
    "date_range": "Rango de fechas",
    "from": "En",
    "to": "A",
    "target_price_greater_then_zero": "El precio objetivo debe ser menor que el precio de activación y mayor que",
    "target_price_market_range_greater_zero": "El Precio Objetivo debe ser menor que el Rango de Mercado y Mayor que",
    "order_list": "Lista de pedidos",
    "close_all_trades": "Cerrar todos los oficios",
    "instrument_name": "Nombre del instrumento",
    "trade_logs": "Registros comerciales",
    "transaction_ID": "ID de transacción",
    "add_more_leader": "Añadir más líder",
    "total_Profit": "Beneficio total",
    "invested": "Invertido",
    "market101_guard_enabled": "Market101 Guard Activado",
    "excessive_losses": "El Líder ha sido desactivado debido a pérdidas excesivas.",
    "filter": "Filtro",
    "remember_filters": "Recuerde los filtros",
    "toggle": "Toggle",
    "matrix": "Matriz",
    "select_all": "Seleccionar todo",
    "term": "Plazo",
    "apply": "Aplique",
    "clear_all": "Borrar todo",
    "follow_more": "Seguir Más",
    "go_to_dashboard": "Ir al panel de control",
    "are_you_sure_stop_coping": "¿Está seguro de que quiere dejar de copiar a este Maestro?",
    "invested_amount": "Importe invertido",
    "max": "Max",
    "insufficient_funds": "Insuficiencia de fondos en la cuenta.",
    "enter_valid_amount": "Por favor, introduzca un importe válido.",
    "maximum_amount_allowed": "El importe máximo permitido es de hasta",
    "available_capital": "Capital disponible",
    "copy_open_trades": "Copiar operaciones abiertas",
    "stop_following": "Dejar de seguir",
    "leaders": "Líderes",
    "back_to_manual_trading": "Volver a Comercio manual",
    "advanced_stats": "Estadísticas avanzadas",
    "view_all": "Ver todos",
    "roi": "ROI",
    "load_more": "Cargar más",
    "powered_by": "Desarrollado por",
    "act_trader": "Actuar como comerciante"
  }


// WEBPACK FOOTER //
// ./src/plugins/lang/languages/es.js